import { Box, Container } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../../shared/components/variables';

export const Header = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 0;
`;

export const InfoSection = styled(Box)`
  padding-bottom: 8px;
  border-bottom: 1px solid ${colorTokens.border.main};
`;

export const ContactSection = styled(Box)`
  display: flex;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid var(--border-main, #cbd1d6);
  background: var(--surface-light, #f7fafc);
`;
